import { render, staticRenderFns } from "./EditBasePlan.vue?vue&type=template&id=6c79bb08&"
import script from "./EditBasePlan.vue?vue&type=script&lang=js&"
export * from "./EditBasePlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports